import cn from 'classnames';
import type { ReactNode } from 'react';
import DesktopLogo from '@packages/shared/assets/logo/nebula-redesign-desktop.png';
import MobileLogo from '@packages/shared/assets/logo/nebula-redesign-mobile.png';
import Image from '@packages/shared/core/common/components/common/Image';
import HeaderMenu from './HeaderMenu';
import styles from './Header.module.scss';

export type HeaderProps = {
  logoClassName?: string;
  className?: string;
  shouldShowMenu?: boolean;
  hasButtonBack?: boolean;
  id?: string;
  children?: ReactNode;
  onLogoClick?: () => void;
  menuClassName?: string;
};

const Header = ({
  className,
  id = '',
  shouldShowMenu = true,
  hasButtonBack = true,
  onLogoClick = () => {},
  children,
  menuClassName = '',
  logoClassName,
}: HeaderProps) => {
  return (
    <header
      className={cn(styles.header, { [styles.headerWithoutBack]: !hasButtonBack }, className)}
      id={id}
    >
      <button type="button" className={styles.logoButton} onClick={onLogoClick} aria-label="Nebula Logo">
        <Image
          type="future"
          src={MobileLogo}
          alt="Nebula Logo"
          width={24}
          height={24}
          className={cn(styles.logoMobile, logoClassName)}
          priority
          unoptimized
          loading="eager"
        />
        <Image
          type="future"
          src={DesktopLogo}
          alt="Nebula Logo"
          width={92}
          height={24}
          className={cn(styles.logoDesktop, logoClassName)}
          priority
          unoptimized
          loading="eager"
        />
      </button>

      {shouldShowMenu && <HeaderMenu className={cn(styles.menu, menuClassName)} />}

      {children}
    </header>
  );
};

export default Header;
